/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type USER_STATUS = "ACTIVE" | "BANNED" | "PREMOD" | "SUSPENDED" | "WARNED" | "%future added value";
export type AnsweredCommentsContainer_viewer = {
    readonly status: {
        readonly current: ReadonlyArray<USER_STATUS>;
    };
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentContainer_viewer">;
    readonly " $refType": "AnsweredCommentsContainer_viewer";
};
export type AnsweredCommentsContainer_viewer$data = AnsweredCommentsContainer_viewer;
export type AnsweredCommentsContainer_viewer$key = {
    readonly " $data"?: AnsweredCommentsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AnsweredCommentsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnsweredCommentsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "current",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnsweredCommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '3318ac99455fc0d44cf19b0b2cadc9da';
export default node;
